import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import supabase from '../../server/supabaseClient';

//Allows a user to enter their username and password
//If successful, will redirect to "My Profile page"

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [resetError, setResetError] = useState(null);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    //sign in user

    let {error} = await supabase.auth.signInWithPassword({
      email:email,
      password:password,
    });

    if (error){
      setError(error.message); //Display error message
    } else {
      setSuccess(true); //login successful!
      console.log('Login Successful');
      navigate('/dashboard')
    };
    
  };

  const handleForgotPassword = async () => {
    if (!email.trim()) {
      setResetError('Please enter your email address first');
      return;
    }

    setResetError(null);
    setResetEmailSent(false);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) {
        setResetError(error.message);
      } else {
        setResetEmailSent(true);
        setResetError(null);
      }
    } catch (error) {
      console.error('Password reset error:', error);
      setResetError('An error occurred while sending the reset email. Please try again.');
    }
  };

  return (
    <>
    <div className="bg-gray-100 min-h">
      <div className='bg-gray-200 min-h-screen md:flex'>
        <div className="max-w-2xl mx-auto md:flex m-0 items-center">
          <div>
          <img src='https://qdpammoeepwgapqyfrrh.supabase.co/storage/v1/object/public/speak-it-brand-assets/speak_itLogo.png' 
              alt='Speak It Logo' 
              className='w-full max-w-md mx-auto p-1'/>
        <div>
           <p className='text-4xl font-medium text-heading mb-4 text-center'>Speak-It!</p>
          <p
           className='text-lg text-center italic mx-4'
          >"Speak Now Or Forever hold Your Peace"</p>
        </div>
        </div>
      <div className='flex flex-col items-center justify-center p-4 mt-2 z-10'>
      <form onSubmit={handleLogin}
            className='flex flex-col bg-gray-300 justify-center mx-8 rounded-md p-8 mb-8'>
        <div>
        <label>Email: </label>
        </div>
        <div>
        <input
        type='email'
        placeholder='Email'
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className='border-2 border-gray-500 border-solid rounded-md p-2'
        />
        </div>
        <div>
          <div>
          <label>Password: </label>
          </div>
        <input
        type='password'
        placeholder='Password'
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        className='border-2 border-gray-500 border-solid rounded-md p-2'
        />
        </div>
        <div className='flex flex-col items-center justify-center'>
      {error && <p className="text-red-600">{error}, Did You Validate Your Email?</p>}
      {success && <p className="text-green-500">{success}</p>}
      <button type='submit'
        className='bg-blue-500 text-white rounded-md p-2 w-full mt-4'
      >Login</button>
      
      {/* Forgot Password Section */}
      <div className='mt-4 text-center'>
        <button 
          type='button'
          onClick={handleForgotPassword}
          className='text-blue-400 hover:text-blue-300 text-sm underline'
        >
          Forgot Password?
        </button>
        {resetError && <p className="text-red-600 text-sm mt-2">{resetError}</p>}
        {resetEmailSent && <p className="text-green-500 text-sm mt-2">Password reset email sent! Please check your inbox.</p>}
      </div>
      
      <p className='mt-4'>Don't have an account?</p>
        <div>
        <button 
        onClick={() => navigate('/Signup')}
        className='bg-blue-500 border-2 border-solid text-white p-2 rounded-md w-full'
          >Sign up</button>
        </div>
      </div>
    </form>
    <div>
     <Link 
      to="/privacy-policy" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="text-blue-500 hover:text-blue-300"
    >
      Privacy Policy
    </Link>
    </div>
    </div>
    </div>
  </div>
</div>
        </>
  );
}

export default Login;
